/**
 * 穴位模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取穴位列表
export const acupointList = (params) => {
  return req.get('/hosp/acupoint/list', params);
}

// 新增穴位
export const acupointAdd = (params) => {
  return req.post('/hosp/acupoint', params);
}

// 修改穴位信息
export const acupointEdit = (params) => {
  return req.put('/hosp/acupoint', params);
}

// 查询穴位、部位树
export const listAcupointSpecies = (params) => {
  return req.get('/hosp/acupoint/listAcupointSpecies', params);
}
